import React from 'react'
import classes from './NavigationItems.css'
import NavigationItem from '../NavigationItems/NavigationItem/NavigationItem'
import {} from 'react-router-dom'

const navigationItems = (props) => {
    return (
      <ul className={classes.NavigationItems}>
          <NavigationItem link="/" exact > Burger Builder </NavigationItem>
          { props.isAuth ? <NavigationItem link="/orders" >Orders </NavigationItem>: null}
          {! props.isAuth ? 
            <NavigationItem link="/auth" >Authenticate </NavigationItem> :
            <NavigationItem link="/logout" >Logout </NavigationItem> 
           }
      </ul>
    )
}

export default navigationItems


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js